<template>
  <svg :width="width" :height="height">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.423 6.51L0 11.93l.725.744L6.91 6.51.725.325 0 1.067 5.423 6.51z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Arrow",
  components: {},
  props: {
    color: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  }
});
</script>
